import React from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import ButtonTheme from '../ThemeButton/ThemeButton';
import CloseIcon from '@mui/icons-material/Close';

const ModalBox = ({
  open,
  onClose,
  title,
  body,
  primaryAction,
  primaryActionText,
  secondaryActionText,
  isPrimaryDisabled,
  secondaryAction,
  isTertiaryDisabled,
  tertiaryAction,
  tertiaryActionText,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: '430px',
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          p: 4,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Box
          sx={{
            borderBottom: '1px solid #ccc',
            pb: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ py: 2 }}>
          <Typography variant='body1'>{body}</Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            mt: 2,
          }}
        >
          <ButtonTheme disabled={isPrimaryDisabled} color='primary' onClick={primaryAction}>
            {primaryActionText}
          </ButtonTheme>

          <ButtonTheme
            disabled={isTertiaryDisabled}
            color='primary'
            className='mx-3'
            onClick={tertiaryAction}
          >
            {tertiaryActionText}
          </ButtonTheme>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalBox;
